<template>
  <div class="checkout-builder-settings-menu">
    <div class="selected-tab">
      <bp-button
        v-if="activeScope.parent"
        class="ml-5"
        color="neutral"
        variant="outlined"
        icon="fa fa-angle-left"
        @click="back"
      />
      <div class="active-cell">
        <bp-icon :size="20" :icon="activeScope.icon" />
        <h2>{{ activeScope.name }}</h2>
      </div>
    </div>

    <div class="flex-fill overflow-y-scroll py-6">
      <template v-if="activeScope.options">
        <button
          v-for="option in activeScope.options"
          class="option-cell"
          :class="{ 'd-none d-lg-flex': option == 'elements' }"
          :key="option"
          @click="scope = option"
        >
          <bp-icon
            class="text-neutral-500"
            :size="20"
            :icon="scopes[option].icon"
          />
          <span>{{ scopes[option].name }}</span>
        </button>
      </template>

      <component
        v-else-if="activeScope.component"
        :is="activeScope.component"
      />
    </div>

    <div class="reverse-button d-none d-lg-block" v-if="snapshots.length">
      <bp-button
        class="w-100"
        color="neutral"
        variant="filled-1"
        icon="fa fa-undo"
        label="Desfazer"
        @click="undoSnapshot"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BackgroundColor from "./background/BackgroundColor.vue";
import BackgroundImage from "./background/BackgroundImage.vue";

import DraggableElements from "./elements/DraggableElements.vue";

const scopes = {
  settings: {
    icon: "fa-regular fa-gear",
    name: "Configuração",
    options: [
      "background",
      "elements"
      // "popups",
      // "notifications"
    ]
  },

  background: {
    parent: "settings",
    icon: "fa fa-send-backward",
    name: "Plano de fundo",
    options: ["background-color", "background-image"]
  },
  "background-color": {
    parent: "background",
    icon: "fa-regular fa-palette",
    name: "Cor",
    component: BackgroundColor
  },
  "background-image": {
    parent: "background",
    icon: "fa-regular fa-image",
    name: "Imagem",
    component: BackgroundImage
  },

  elements: {
    parent: "settings",
    icon: "fa fa-icons",
    name: "Elementos",
    component: DraggableElements
  }
  // popups: {
  //   parent: "settings",
  //   icon: "fa fa-square-dashed-circle-plus",
  //   name: "Pop-ups"
  // },
  // notifications: {
  //   parent: "settings",
  //   icon: "fa fa-message-plus",
  //   name: "Notificações"
  // }
};
export default {
  data() {
    return {
      scopes,
      scope: "settings",
      previousScope: ""
    };
  },
  computed: {
    ...mapState("checkoutBuilder", ["snapshots", "components", "background"]),
    activeScope() {
      return scopes[this.scope];
    }
  },
  methods: {
    back() {
      this.scope = this.activeScope?.parent;
    },
    ...mapActions("checkoutBuilder", ["undoSnapshot"])
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-settings-menu {
  height: 100%;
  display: flex;
  flex-direction: column;

  .selected-tab {
    display: flex;
    padding: 16px 0;
    align-items: center;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
    background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
  }

  .active-cell {
    align-items: center;
    padding: 12px 20px;
    display: flex;
    gap: 8px;
  }

  .option-cell {
    background-color: transparent;
    align-items: center;
    padding: 12px 20px;
    display: flex;
    border: none;
    width: 100%;
    gap: 20px;

    &:hover {
      background-color: rgba(25, 25, 34, 0.02);
    }
    &:active {
      background-color: rgba(25, 25, 34, 0.04);
      border-right: 2px solid var(--Semantic-Primary-Accent-600, #6700ee);
      span {
        color: rgba(66, 0, 152, 1);
      }
    }
  }

  .reverse-button {
    padding: 16px;
    backdrop-filter: blur(20px);
    background: var(--Surface-Solid-28, #fff);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
